import type { AbsenceDraft } from "../types";
import { isNewAbsence } from "./draft";

export function saveOrder(
  drafts: Record<number, AbsenceDraft>,
): number[] | null {
  const ids = Object.keys(drafts).map(Number);
  const pending = new Set(ids);

  const blockedBy = (id: number): number | null => {
    const target = drafts[id]?.sameCaseAbsenceId ?? null;

    return null !== target && isNewAbsence(target) && pending.has(target)
      ? target
      : null;
  };

  const ordered: number[] = [];

  while (0 < pending.size) {
    const free = [...pending].filter((id) => null === blockedBy(id));

    if (0 === free.length) {
      return null;
    }

    for (const id of free) {
      ordered.push(id);
      pending.delete(id);
    }
  }

  return ordered;
}
